import React from "react";
import chunk from "lodash/chunk";
import { DomParser } from "../utils/dom-parser";
import { WidgetBox, Empty, Link, Action } from "../components";

const TrainingInProgress = ({ title = "Training in Progress" }) => {
    const parseDataFromDOM = () => {
        const domParser = new DomParser(
            "table[summary='Training in Progress Content'] > tbody > tr > td"
        );
        const columns = domParser.columns;
        return chunk(columns, 2).map(row => {
            const [td1, td2] = row;
            return {
                title: domParser.singleAnchor(td1),
                actions: domParser.multiAnchor(td2)
            };
        });
    };

    const data = parseDataFromDOM();

    let titleLink = null;
    let titleLinkEl = document.querySelector(
        "div[data-tag='pnlNew'] a.titleLink"
    );

    if (titleLinkEl) {
        titleLink = titleLinkEl.getAttribute("href");
    }

    return (
        <WidgetBox
            title={title}
            type="purple"
            noPadding
            floatingImg="flag"
            titleLink={titleLink}
        >
            <div style={{ marginTop: "16px" }} className="v-list">
                <div style={{ margin: "0px 45px" }}>
                    <Empty isEmpty={data.length === 0} />
                </div>
                {data.map((o, i) => (
                    <div
                        key={i}
                        className="v-list-item v-list-item--alternate v-list-item--j-between"
                    >
                        <Action classes="v-list-item__title" {...o.title} />
                        <div className="my-training__actions">
                            {o.actions.map((a) => (
                                <Action key={a.actionId} {...a} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            {titleLink && (
                <div style={{ padding: "0px 45px 25px 45px" }}>
                    <Link text="See all" url={titleLink} />
                </div>
            )}
        </WidgetBox>
    );
};

export default TrainingInProgress;



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/cornerstone-widget-block/widgets/training-in-progress.js